// fields needed to display an instagram post preview
export const PROFILE_PHOTO = 'profile_photo'
export const PROFILE_NAME = 'profile_name'
// media items
export const MEDIA_ITEMS = 'media_items'
export const FILE_URL = 'file_url'
export const FILE_TYPE = 'file_type'

export const POST_DESCRIPTION = 'post_description'
